/**
 * «TODO TU HISTÓRICO» (pantalla 03 del documento de Jesús del 7-09).
 *
 * La tabla entera de sus ajustes, con los nueve números de cada uno. Sale de la portada de Mis
 * macros por «Ver histórico completo ›» y existe por una razón concreta que él escribió: la
 * portada enseñaba los cuatro últimos y detrás de un botón desplegaba el resto AHÍ MISMO. Al
 * cliente con más ajustes de producción eso le volcaba 264 filas en la portada, y «eso es un
 * archivo, no una pantalla».
 *
 * Y EL FILTRO «ESTE CICLO / TODO» (lo que él escribió en «hay que decidir · 2»). Lo que dejó sin
 * decidir de esa ficha era solo si el comparador era de dos ciclos o de dos ajustes sueltos, y eso
 * ya está resuelto: el comparador de dos ajustes se hizo el 7-09 y es lo que dibuja su maqueta. El
 * filtro no dependía de esa duda, así que entra.
 *
 * A qué ciclo pertenece cada ajuste lo dice el servidor (`entradas[].ciclo`), resolviendo la fecha
 * de vigencia contra el cuaderno de ciclos. Al que no tiene cuaderno no se le enseña el selector:
 * un filtro que no filtra nada es peor que ninguno.
 *
 * Mismas columnas y mismas marcas que en la portada, porque es el mismo componente: en rojo lo
 * que cambió respecto a la fila de arriba, calculado, y el peso más bajo en verde y el más alto
 * en rojo.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import HistorialDeMacros from '../components/HistorialDeMacros';

const HistoricoDeMacrosPage = () => {
    const { api } = useAuth();
    const navigate = useNavigate();
    const [entradas, setEntradas] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [soloEsteCiclo, setSoloEsteCiclo] = useState(false);

    useEffect(() => {
        let vivo = true;
        api.get('/macros/historial')
            .then(r => { if (vivo) setEntradas(r.data?.entradas || []); })
            .catch(() => { if (vivo) setEntradas([]); })
            .finally(() => { if (vivo) setCargando(false); });
        return () => { vivo = false; };
    }, [api]);

    // EL CICLO DE AHORA ES EL DEL AJUSTE MÁS RECIENTE, no el número más alto: si el cuaderno
    // tiene un ciclo abierto sin ajustes todavía, filtrar por él dejaría la tabla vacía.
    const todos = entradas || [];
    const cicloActual = todos.find(e => e.ciclo != null)?.ciclo ?? null;
    const hayCiclos = cicloActual != null && todos.some(e => e.ciclo != null && e.ciclo !== cicloActual);
    const visibles = soloEsteCiclo ? todos.filter(e => e.ciclo === cicloActual) : todos;

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-[900px] mx-auto space-y-5 animate-fade-in">
            <button type="button" onClick={() => navigate('/dashboard/macro-calculator')}
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
                data-testid="volver-a-mis-macros">
                <ArrowLeft className="w-4 h-4" /> Mis macros
            </button>

            <h1 className="font-heading text-3xl md:text-4xl font-bold uppercase text-foreground leading-none"
                data-testid="historico-heading">
                Todo tu histórico
            </h1>

            {cargando ? (
                <div className="flex justify-center py-16">
                    <Loader2 className="w-7 h-7 animate-spin text-muted-foreground" />
                </div>
            ) : (entradas || []).length < 2 ? (
                // Con un solo ajuste no hay historia que leer, y el componente no pinta nada:
                // sin esto la pantalla se quedaba en blanco sin decir por qué.
                <p className="text-sm text-muted-foreground" data-testid="historico-vacio">
                    Todavía no tienes ajustes suficientes para ver tu histórico. En cuanto te
                    pongamos los siguientes, aparecerán aquí.
                </p>
            ) : (
                <>
                    {/* Solo si de verdad hay más de un ciclo del que elegir. */}
                    {hayCiclos && (
                        <div className="inline-flex rounded-xl border border-border p-1 gap-1"
                            data-testid="historico-filtro-ciclo">
                            {[[true, `Ciclo ${cicloActual}`], [false, 'Todo']].map(([solo, texto]) => (
                                <button key={texto} type="button" onClick={() => setSoloEsteCiclo(solo)}
                                    className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-colors ${
                                        soloEsteCiclo === solo
                                            ? 'bg-brand text-white'
                                            : 'text-muted-foreground hover:text-foreground'}`}>
                                    {texto}
                                </button>
                            ))}
                        </div>
                    )}
                    {visibles.length < 2 ? (
                        <p className="text-sm text-muted-foreground" data-testid="historico-ciclo-vacio">
                            En este ciclo solo hay un ajuste, así que todavía no hay escalera que
                            leer. Toca «Todo» para ver los anteriores.
                        </p>
                    ) : (
                        <HistorialDeMacros entradas={visibles} completo />
                    )}
                </>
            )}
        </div>
    );
};

export default HistoricoDeMacrosPage;
